import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

// The count behind the Monitoring Requests tab badge and the Monitoring nav
// badge: share and push live requests that need the viewer's review, excluding
// their own outgoing ones. A push live request counts only while its branch
// head is the requested commit.
export function usePendingRequestCount(): number {
  const [grantRequests] = useQuery(queries.reviewableGrantRequests());
  const [pushLiveRequests] = useQuery(queries.reviewablePushLiveRequests());
  return (
    grantRequests.length +
    pushLiveRequests.filter((r) => r.commitId === r.branch?.headCommitId).length
  );
}
